import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    'sessionOutcome.RESOLVED': {
        id: 'sessionOutcome.RESOLVED',
        defaultMessage: 'Resolved',
    },
    'sessionOutcome.UNRESOLVED': {
        id: 'sessionOutcome.UNRESOLVED',
        defaultMessage: 'Unresolved',
    },
    'sessionOutcome.OPEN': {
        id: 'sessionOutcome.OPEN',
        defaultMessage: 'Open',
    },
});

export default enumMessages;
